/**
 * HRNext Performance WebApi
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { IAjaxProvider } from 'jinqu';
import { LinqService, QueryOptions } from 'linquest';
import {
  ThreeSixtyPeriodEmployeeBulkRequestDto,
  ThreeSixtyPeriodResultDto,
  ThreeSixtyPeriodEmployeeDto,
} from './models';

/**
 * ThreeSixtyPeriodEmployeeApi - API class
 */
export class ThreeSixtyPeriodEmployeeApi extends LinqService {

  /**
   * Creates a new ThreeSixtyPeriodEmployeeApi class.
   *
   * @param ajaxProvider The Linquest Ajax Provider to inject. When not specified, default Fetch provider will be used.
   */
  constructor(ajaxProvider?: IAjaxProvider) {
    super("/performance-api", ajaxProvider);
  }

  /**
   * @param dto 
   */
  addOrUpdateAsync(dto?: ThreeSixtyPeriodEmployeeDto, options?: QueryOptions) {
    // create query
    const url = `/ThreeSixtyPeriodEmployee/AddOrUpdateAsync`;
    let query = this.createQuery<any>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'POST';
    options.params = options.params || [];
    options.headers = options.headers || {};

    // set body parameter
    options.data = dto;
    query = query.withOptions(options);

    return query.firstAsync();
  }

  /**
   * @param bulkRequestDto 
   */
  addOrUpdateBulk(bulkRequestDto?: ThreeSixtyPeriodEmployeeBulkRequestDto, options?: QueryOptions) {
    // create query
    const url = `/ThreeSixtyPeriodEmployee/AddOrUpdateBulk`;
    let query = this.createQuery<ThreeSixtyPeriodResultDto>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'POST';
    options.params = options.params || [];
    options.headers = options.headers || {};

    // set body parameter
    options.data = bulkRequestDto;
    query = query.withOptions(options);

    return query.firstAsync();
  }

  /**
   * @param id 
   */
  deleteAsync(id?: string, options?: QueryOptions) {
    // create query
    const url = `/ThreeSixtyPeriodEmployee/DeleteAsync`;
    let query = this.createQuery<any>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'GET';
    options.params = options.params || [];
    options.headers = options.headers || {};

    // set query parameters
    options.params.push({ key: 'Id', value: id && id.toString() });
    query = query.withOptions(options);

    return query.firstAsync();
  }

  /**
   * @param employeeId 
   * @param threeSixtyPeriodId 
   */
  deleteThreeSixtyPeriodAndEvaluationOfEmployee(employeeId?: string, threeSixtyPeriodId?: string, options?: QueryOptions) {
    // create query
    const url = `/ThreeSixtyPeriodEmployee/DeleteThreeSixtyPeriodAndEvaluationOfEmployee`;
    let query = this.createQuery<any>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'POST';
    options.params = options.params || [];
    options.headers = options.headers || {};

    // set query parameters
    options.params.push({ key: 'employeeId', value: employeeId && employeeId.toString() });
    // set query parameters
    options.params.push({ key: 'threeSixtyPeriodId', value: threeSixtyPeriodId && threeSixtyPeriodId.toString() });
    query = query.withOptions(options);

    return query.firstAsync();
  }

  /**
   * @param id 
   */
  getAsync(id?: string, options?: QueryOptions) {
    // create query
    const url = `/ThreeSixtyPeriodEmployee/GetAsync`;
    let query = this.createQuery<ThreeSixtyPeriodEmployeeDto>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'GET';
    options.params = options.params || [];
    options.headers = options.headers || {};

    // set query parameters
    options.params.push({ key: 'Id', value: id && id.toString() });
    query = query.withOptions(options);

    return query.firstAsync();
  }

  /**
   * @param id 
   */
  getTranslatedAsync(id?: string, options?: QueryOptions) {
    // create query
    const url = `/ThreeSixtyPeriodEmployee/GetTranslatedAsync`;
    let query = this.createQuery<ThreeSixtyPeriodEmployeeDto>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'GET';
    options.params = options.params || [];
    options.headers = options.headers || {};

    // set query parameters
    options.params.push({ key: 'Id', value: id && id.toString() });
    query = query.withOptions(options);

    return query.firstAsync();
  }

  /**
   */
  list(options?: QueryOptions) {
    // create query
    const url = `/ThreeSixtyPeriodEmployee/List`;
    let query = this.createQuery<ThreeSixtyPeriodEmployeeDto>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'GET';
    options.params = options.params || [];
    options.headers = options.headers || {};

    query = query.withOptions(options);

    return query;
  }

  /**
   */
  listTranslated(options?: QueryOptions) {
    // create query
    const url = `/ThreeSixtyPeriodEmployee/ListTranslated`;
    let query = this.createQuery<ThreeSixtyPeriodEmployeeDto>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'GET';
    options.params = options.params || [];
    options.headers = options.headers || {};

    query = query.withOptions(options);

    return query;
  }

  /**
   * @param dto 
   */
  saveAsync(dto?: ThreeSixtyPeriodEmployeeDto, options?: QueryOptions) {
    // create query
    const url = `/ThreeSixtyPeriodEmployee/SaveAsync`;
    let query = this.createQuery<any>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'POST';
    options.params = options.params || [];
    options.headers = options.headers || {};

    // set body parameter
    options.data = dto;
    query = query.withOptions(options);

    return query.firstAsync();
  }
}
